import { render, staticRenderFns } from "./auth-forgot.vue?vue&type=template&id=c3595136"
import script from "./auth-forgot.vue?vue&type=script&lang=js"
export * from "./auth-forgot.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports